import { CountryGroup } from '@faire/web-api--source/indigofair/data/CountryGroup';
import { IBrandDiscount } from '@faire/web-api--source/indigofair/data/IBrandDiscount';
import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';
import { IInstrumentTypeEnum } from '@faire/web-api--source/indigofair/data/IInstrumentTypeEnum';

export namespace IOffer {
  export enum RetailerOfferName {
    /**
     * @deprecated
     */
    POST_ORDER_INSIDER_ENROLLMENT = 'POST_ORDER_INSIDER_ENROLLMENT',
    /**
     * @deprecated
     */
    POST_ORDER_INSIDER_ENROLLMENT_V2 = 'POST_ORDER_INSIDER_ENROLLMENT_V2',
    OPENING_ORDER_DISCOUNT = 'OPENING_ORDER_DISCOUNT',
    /**
     * Promotional pricing for monthly billed Insider membership fees when retailers are ineligible for annual billing
     */
    INSIDER_SIGNUP_INCENTIVE = 'INSIDER_SIGNUP_INCENTIVE',
    /**
     * @deprecated
     */
    FIRST_ORDER_INCENTIVE = 'FIRST_ORDER_INCENTIVE',
    /**
     * @deprecated
     */
    RE_ENGAGEMENT_INCENTIVE = 'RE_ENGAGEMENT_INCENTIVE',
    /**
     * @deprecated
     */
    FIRST_ORDER_INCENTIVE_V2_100_OFF_MIN_200 = 'FIRST_ORDER_INCENTIVE_V2_100_OFF_MIN_200',
    /**
     * @deprecated
     */
    FIRST_ORDER_INCENTIVE_V2_50_PERCENT_OFF = 'FIRST_ORDER_INCENTIVE_V2_50_PERCENT_OFF',
    CUSTOM_OFFER = 'CUSTOM_OFFER',
    EUROPEAN_LOCAL_DISCOUNT = 'EUROPEAN_LOCAL_DISCOUNT',
    /**
     * @deprecated
     */
    FIRST_ORDER_INCENTIVE_V2_30_PERCENT_OFF = 'FIRST_ORDER_INCENTIVE_V2_30_PERCENT_OFF',
    /**
     * @deprecated
     */
    FIRST_ORDER_INCENTIVE_V3_CONTROL = 'FIRST_ORDER_INCENTIVE_V3_CONTROL',
    /**
     * @deprecated
     */
    FIRST_ORDER_INCENTIVE_V3_OPTIMIZED_PROMOTION = 'FIRST_ORDER_INCENTIVE_V3_OPTIMIZED_PROMOTION',
    /**
     * @deprecated
     */
    FIRST_ORDER_INCENTIVE_V3_OPTIMIZED_PROMOTION_PLUS = 'FIRST_ORDER_INCENTIVE_V3_OPTIMIZED_PROMOTION_PLUS',
    /**
     * @deprecated
     */
    FD_CREDIT_MARKETPLACE_PIVOT = 'FD_CREDIT_MARKETPLACE_PIVOT',
    /**
     * @deprecated
     */
    PERSONALIZED_FIRST_ORDER_INCENTIVE_V1 = 'PERSONALIZED_FIRST_ORDER_INCENTIVE_V1',
    PERSONALIZED_FIRST_ORDER_INCENTIVE_V1_50_PERCENT = 'PERSONALIZED_FIRST_ORDER_INCENTIVE_V1_50_PERCENT',
    /**
     * @deprecated
     */
    PERSONALIZED_FIRST_ORDER_INCENTIVE_V1_CONTROL = 'PERSONALIZED_FIRST_ORDER_INCENTIVE_V1_CONTROL',
    FIRST_ORDER_INCENTIVE_AUTO_EXTEND_V1 = 'FIRST_ORDER_INCENTIVE_AUTO_EXTEND_V1',
    GRANT_RETAILER_FREE_SHIPPING_FOR_BRAND = 'GRANT_RETAILER_FREE_SHIPPING_FOR_BRAND',
    ACH_PROACTIVE_LIMIT_INCREASE = 'ACH_PROACTIVE_LIMIT_INCREASE',
    FAIRE_DIRECT_MARKETPLACE_DISCOUNT = 'FAIRE_DIRECT_MARKETPLACE_DISCOUNT',
    /**
     * @deprecated
     */
    SHOPIFY_FIRST_ORDER_DISCOUNT = 'SHOPIFY_FIRST_ORDER_DISCOUNT',
    /**
     * @deprecated
     */
    SHOPIFY_NEXT_ORDER_DISCOUNT = 'SHOPIFY_NEXT_ORDER_DISCOUNT',
    SHOPIFY_FREE_ONE_YEAR_INSIDER_INCENTIVE = 'SHOPIFY_FREE_ONE_YEAR_INSIDER_INCENTIVE',
    SHOPIFY_PAID_PLAN_ENROLLMENT = 'SHOPIFY_PAID_PLAN_ENROLLMENT',
    ACH_TERMS_PRE_APPROVAL = 'ACH_TERMS_PRE_APPROVAL',
    SHOPIFY_FIRST_ORDER_INCENTIVE_OFFER = 'SHOPIFY_FIRST_ORDER_INCENTIVE_OFFER',
    SHOPIFY_NEXT_ORDER_INCENTIVE_OFFER = 'SHOPIFY_NEXT_ORDER_INCENTIVE_OFFER',
    /**
     * @deprecated
     */
    EVERGREEN_FIRST_ORDER_INCENTIVE_V1 = 'EVERGREEN_FIRST_ORDER_INCENTIVE_V1',
    GENERIC_OFFER = 'GENERIC_OFFER',
    PROMO_CODE = 'PROMO_CODE',
    PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_50_PERCENT = 'PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_50_PERCENT',
    PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_AUTO_EXTEND = 'PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_AUTO_EXTEND',
    /**
     * @deprecated
     */
    EVERGREEN_PERSONALIZED_FIRST_ORDER_INCENTIVE_V2 = 'EVERGREEN_PERSONALIZED_FIRST_ORDER_INCENTIVE_V2',
    EVERGREEN_MARKETPLACE_DISCOUNT = 'EVERGREEN_MARKETPLACE_DISCOUNT',
    FAIRE_DIRECT_SIGNUP_INCENTIVE = 'FAIRE_DIRECT_SIGNUP_INCENTIVE',
    /**
     * Replaced by POST_FIRST_CONFIRMED_ORDER_INCENTIVE_DISCOUNT as the name is too long to fit into the offers table
     * @deprecated
     */
    POST_FIRST_CONFIRMED_ORDER_DISCOVERY_INCENTIVE_DISCOUNT = 'POST_FIRST_CONFIRMED_ORDER_DISCOVERY_INCENTIVE_DISCOUNT',
    POST_FIRST_CONFIRMED_ORDER_INCENTIVE_DISCOUNT = 'POST_FIRST_CONFIRMED_ORDER_INCENTIVE_DISCOUNT',
    /**
     * Reward for using Faire Pay
     */
    FAIRE_PAY_REWARD = 'FAIRE_PAY_REWARD',
    /**
     * Reward for enrolling Faire Pay
     */
    FAIRE_PAY_ENROLLMENT_CREDIT = 'FAIRE_PAY_ENROLLMENT_CREDIT',
    LAST_CHANCE_FIRST_ORDER_INCENTIVE_V1 = 'LAST_CHANCE_FIRST_ORDER_INCENTIVE_V1',
    PERSONALIZED_LAST_CHANCE_FIRST_ORDER_INCENTIVE_V1 = 'PERSONALIZED_LAST_CHANCE_FIRST_ORDER_INCENTIVE_V1',
    EMAIL_VERIFICATION_FOR_TERMS_PRE_FCO = 'EMAIL_VERIFICATION_FOR_TERMS_PRE_FCO',
    EMAIL_VERIFICATION_FOR_TERMS_POST_FCO = 'EMAIL_VERIFICATION_FOR_TERMS_POST_FCO',
    /**
     * Reward for pre-enrolling Faire Pay
     */
    FAIRE_PAY_ONE_TIME_DISCOUNT = 'FAIRE_PAY_ONE_TIME_DISCOUNT',
    /**
     * Free period of Insider given as a retention offer to cancelling Retailers
     */
    INSIDER_RETENTION_OFFER = 'INSIDER_RETENTION_OFFER',
    SIGNUP_EMAIL_VERIFICATION_FOR_TERMS = 'SIGNUP_EMAIL_VERIFICATION_FOR_TERMS',
    /**
     * Promotional pricing for annually billed Insider membership fees
     */
    INSIDER_SIGNUP_INCENTIVE_ANNUAL = 'INSIDER_SIGNUP_INCENTIVE_ANNUAL',
    /**
     * Promotional pricing for monthly billed Insider membership fees when retailers are eligible for annual billing
     */
    INSIDER_SIGNUP_INCENTIVE_MONTHLY = 'INSIDER_SIGNUP_INCENTIVE_MONTHLY',
    PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_LAST_CHANCE = 'PERSONALIZED_FIRST_ORDER_INCENTIVE_V2_LAST_CHANCE',
    TRIGGERED_FIRST_ORDER_INCENTIVE = 'TRIGGERED_FIRST_ORDER_INCENTIVE',
    TRIGGERED_FD_FIRST_ORDER_INCENTIVE = 'TRIGGERED_FD_FIRST_ORDER_INCENTIVE',
    WINBACK_BAD_ORDER_INCENTIVE = 'WINBACK_BAD_ORDER_INCENTIVE',
  }

  export enum State {
    ELIGIBLE = 'ELIGIBLE',
    APPLIED = 'APPLIED',
    EXPIRED = 'EXPIRED',
    REVOKED = 'REVOKED',
  }

  export enum DiscountBenefitLevel {
    DISCOUNT_BENEFIT_LEVEL_UNKNOWN = 'DISCOUNT_BENEFIT_LEVEL_UNKNOWN',
    ORDER = 'ORDER',
    BRAND_ORDER = 'BRAND_ORDER',
  }

  export enum Source {
    SOURCE_UNKNOWN = 'SOURCE_UNKNOWN',
    BATCH_INCENTIVE_SYSTEM = 'BATCH_INCENTIVE_SYSTEM',
    FIRST_ORDER_CANCELLATION = 'FIRST_ORDER_CANCELLATION',
    FAIRE_DIRECT_SIGN_UP = 'FAIRE_DIRECT_SIGN_UP',
    FAIRE_OFFER = 'FAIRE_OFFER',
    NON_FAIRE_DIRECT_SIGN_UP = 'NON_FAIRE_DIRECT_SIGN_UP',
    ADMIN_GRANTED = 'ADMIN_GRANTED',
    FOI_S3_BASED_BACKFILL = 'FOI_S3_BASED_BACKFILL',
    FAIRE_DIRECT_RETAILER_FOI_ORDER_CANCELLATION = 'FAIRE_DIRECT_RETAILER_FOI_ORDER_CANCELLATION',
    TRIGGERED_INCENTIVE_EVENT = 'TRIGGERED_INCENTIVE_EVENT',
  }

  export enum OfferCondition {
    OFFER_CONDITION_UNKNOWN = 'OFFER_CONDITION_UNKNOWN',
    LINK_PLAID_ACH = 'LINK_PLAID_ACH',
    VERIFY_RETAILER_EMAIL = 'VERIFY_RETAILER_EMAIL',
  }

  export namespace IBrandDiscountBenefit {
    /**
     * Return an instance of IBrandDiscountBenefit with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IBrandDiscountBenefit>
    ): IBrandDiscountBenefit =>
      ({
        excluded_brands: [],
        ...(partial ?? {}),
      }) as IBrandDiscountBenefit;
  }

  export interface IBrandDiscountBenefit {
    /**
     * Type of the BrandDiscount that would be given
     */
    brand_discount_type: keyof typeof IBrandDiscount.Type | undefined;
    /**
     * Give discount only when total order amount exceed this value
     */
    min_order_amount: IFaireMoney | undefined;
    /**
     * If true the benefit will work only for the first order for the brand
     */
    first_order_for_brand: boolean | undefined;
    /**
     * The flat-off discount amount
     */
    discount_amount: IFaireMoney | undefined;
    /**
     * Flat-off discount can be applied on each brand order individually or distributed between brand order of the same order
     */
    discount_level: keyof typeof IOffer.DiscountBenefitLevel | undefined;
    /**
     * The %-based discount
     */
    discount_bps: number | undefined;
    /**
     * Example: "Give 5% off up to $100", %-based discount is converted to flat-off discount to apply the cap
     */
    discount_bps_cap_amount: IFaireMoney | undefined;
    /**
     * Defines if the offer gives free shipping
     */
    free_shipping: boolean | undefined;
    /**
     * Offer can only be applied to brands within the country group
     */
    brand_country_group: keyof typeof CountryGroup | undefined;
    /**
     * If true the benefit will work only when brand.basedIn = retailer.country
     */
    local_country: boolean | undefined;
    brand_token: string | undefined;
    /**
     * If populated the benefit will only apply to brandTokens NOT in this list
     * @protobufOption (.faire.common.tokenType) = BRAND
     */
    excluded_brands: Array<string>;
    /**
     * If populated the promo code needs to be supplied at checkout in order for it to apply
     */
    promo_code: string | undefined;
    /**
     * If true the benefit won't work if any brands in the order have an FD relationship
     */
    non_faire_direct_order: boolean | undefined;
    /**
     * If true the benefit will only work if all brands in the order have an FD relationship
     */
    only_faire_direct_order: boolean | undefined;
    /**
     * If true the benefit will only work for brands that have onboarded recently
     */
    new_brands_only: boolean | undefined;
    /**
     * If supplied, the benefit will only apply to brand orders checked out with the instrument type
     */
    instrument_type:
      | keyof typeof IInstrumentTypeEnum.InstrumentType
      | undefined;
  }

  /**
   * Return an instance of IOffer with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IOffer>): IOffer =>
    ({
      ...(partial ?? {}),
    }) as IOffer;
}

export interface IOffer {
  token: string | undefined;
  retailer_token: string | undefined;
  state: keyof typeof IOffer.State | undefined;
  offer_identifier: string | undefined;
  name: keyof typeof IOffer.RetailerOfferName | undefined;
  source: keyof typeof IOffer.Source | undefined;
  cta_text: string | undefined;
  title: string | undefined;
  description: string | undefined;
  created_at: number | undefined;
  expire_at: number | undefined;
  /**
   * @deprecated
   */
  offer_amount: IFaireMoney | undefined;
  applied_at: number | undefined;
  /**
   * @deprecated
   */
  discount_bps: number | undefined;
  last_seen_at: number | undefined;
  /**
   * @deprecated
   */
  minimum_amount: IFaireMoney | undefined;
  /**
   * @deprecated
   */
  max_offer_amount: IFaireMoney | undefined;
  discount_benefit: IOffer.IBrandDiscountBenefit | undefined;
  membership_price: IFaireMoney | undefined;
  /**
   * Non-recurring offer is applied only once (-$X off the next order), recurring works until it expires
   */
  recurring: boolean | undefined;
  terms_limit_increase: IFaireMoney | undefined;
  offer_condition: keyof typeof IOffer.OfferCondition | undefined;
  /**
   * Only supported for OPENING_ORDER_DISCOUNT incentive type
   */
  suppress_emails: boolean | undefined;
  new_terms_limit: IFaireMoney | undefined;
  idempotence_token: string | undefined;
  incentive_campaign_identifier: string | undefined;
}
